import {AuthModel} from './_models'
import {getApiBaseUrl} from '../../../config/api'
import {clearTechnicalReportCacheForUser} from '../../gis/Reports/TechnicalReport/technicalReportCache'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

const removeAuthSession = (currentUser?: unknown) => {
  removeAuth()
  clearTechnicalReportCacheForUser({currentUser})
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  const apiBaseUrl = getApiBaseUrl()
  // Central API strategy: axios uses relative `/api/...` endpoints and this baseURL handles external domains.
  if (apiBaseUrl) {
    axios.defaults.baseURL = apiBaseUrl
  }
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      return applyStoredAuthorization(config, auth)
    },
    (err: any) => Promise.reject(err)
  )
}

export const applyStoredAuthorization = <T extends {headers: {Authorization?: string}}>(
  config: T,
  auth?: AuthModel
): T => {
  if (auth?.api_token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${auth.api_token}`
  }
  return config
}

export {getAuth, setAuth, removeAuth, removeAuthSession, AUTH_LOCAL_STORAGE_KEY}
